@if (hasTitle()) {
    <section class="position-relative item-slider--title" [class.with-controls]="arrowsInHeader()">
        <ng-content select="[title]" />

        @if (arrowsInHeader()) {
            <div class="item-slider--header-controls d-flex align-items-center">
                <button class="item-slider--btn" [attr.aria-label]="'common.form.button.previous' | translate" (click)="onClick(el, backwards)">
                    <fa-icon [icon]="backwards === 'left' ? leftArrow : rightArrow" />
                </button>
                <button class="item-slider--btn" [attr.aria-label]="'common.form.button.next' | translate" (click)="onClick(el, forwards)">
                    <fa-icon [icon]="forwards === 'left' ? leftArrow : rightArrow" />
                </button>
            </div>
        }
    </section>
}

<section class="position-relative item-slider--content" [class.with-performance]="showPerformance()">
    <div class="position-relative item-slider--performance">
        <ng-content select="[performance]"></ng-content>
    </div>
    <div class="position-relative item-slider--carousel">
        @if (!arrowsInHeader()) {
            <button class="item-slider--btn" (click)="onClick(el, backwards)">
                <fa-icon [icon]="backwards === 'left' ? leftArrow : rightArrow" />
            </button>
        }

        <div class="position-relative item-slider--stats" #el>
            <ng-content />
        </div>

        @if (!arrowsInHeader()) {
            <button class="item-slider--btn" (click)="onClick(el, forwards)">
                <fa-icon [icon]="forwards === 'left' ? leftArrow : rightArrow" />
            </button>
        }
    </div>
</section>
